/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../ui/Title";
import Text from "../ui/Text";
import Stack from "../ui/Stack";
import { useStepManager } from "../../hooks/useStepManager";
import BookingStepItem from "./steps/BookingStepItem";

const StyledSelectStepItem = styled((props) => <BookingStepItem {...props} />)`
  padding: 1.375rem 1rem 1.375rem 1.5rem;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 1rem;
  }
`;

const SelectStepItemInner = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const SelectStepItemIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid rgba(${({ theme }) => theme.colors.iconStroke.rgba});

  svg {
    width: 20px;
    height: 20px;
  }
`;

const SelectStepItem = ({ icon, label, description, descriptionColor, navigateTo, onSelect, selectedStep, disabled }) => {
  const { navigateToStep } = useStepManager();

  const handleStepSelect = () => {
    if (onSelect) return onSelect();
    navigateToStep(navigateTo);
  };

  return (
    <StyledSelectStepItem onClick={handleStepSelect} disabled={disabled}>
      {!selectedStep && (
        <SelectStepItemInner>
          <SelectStepItemIcon>{icon}</SelectStepItemIcon>
          {description ? (
            <Stack $gap="0.25rem">
              <Title size="h3">{label}</Title>
              <Text color={descriptionColor}>{description}</Text>
            </Stack>
          ) : (
            <Title size="h3">{label}</Title>
          )}
        </SelectStepItemInner>
      )}

      {selectedStep}
    </StyledSelectStepItem>
  );
};

export default SelectStepItem;
